if (window.calculatorsUnitaireLoaded) {
  console.log("STC: Calculators Unitaire JS already loaded, skipping execution.");
} else {
  window.calculatorsUnitaireLoaded = true;

  // ----- Background highlight for quantity radios -----
  setTimeout(() => {
    document.querySelectorAll('input[name="quantity"]').forEach((radio) => {
      radio.addEventListener("change", function () {
        document.querySelectorAll(".quantity-options").forEach((option) => {
          option.style.background = "none";
        });
        if (this.checked) {
          const option = this.closest(".quantity-options");
          if (option) option.style.background = "#ececec";
        }
      });
      if (radio.checked) {
        const option = radio.closest(".quantity-options");
        if (option) option.style.background = "#ececec";
      }
    });
  }, 2000);

  // ----- Size dropdown behaviour -----
  setTimeout(() => {
    const sizeDropdown = document.querySelector(".size-dropdown");
    if (sizeDropdown) {
      sizeDropdown.addEventListener("click", function () {
        const sizeOptions = document.getElementById("size-options");
        if (sizeOptions) {
          sizeOptions.style.display = sizeOptions.style.display === "block" ? "none" : "block";
        }
      });
    }

    document.querySelectorAll('input[name="dimensions"]').forEach(function (radio) {
      function handleEvent() {
        const label = this.closest("label");
        if (!label) return;
        const selectedValue = label.textContent.trim();
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown) dropdown.textContent = selectedValue;
        const sizeOptions = document.getElementById("size-options");
        if (sizeOptions) sizeOptions.style.display = "none";
      }
      radio.addEventListener("change", handleEvent);
      radio.addEventListener("click", handleEvent);
    });

    const checkedRadio = document.querySelector('input[name="dimensions"]:checked');
    if (checkedRadio) {
      const label = checkedRadio.closest("label");
      if (label) {
        const firstSelectedValue = label.textContent.trim();
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown) dropdown.textContent = firstSelectedValue;
      }
    }
  }, 3000);

  // ----- Get variant from URL -----
  function getVariantFromURL() {
    const variantRadios = document.querySelector('variant-radios, variant-selects');
    if (variantRadios && variantRadios.currentVariant && variantRadios.currentVariant.id) {
      return parseInt(variantRadios.currentVariant.id);
    }
    const inputId = document.querySelector('input[name="id"]');
    if (inputId && inputId.value && !isNaN(parseInt(inputId.value))) {
      return parseInt(inputId.value);
    }
    const urlParams = new URLSearchParams(window.location.search);
    const variant = urlParams.get("variant");
    if (variant) {
      return parseInt(variant);
    } else {
      const varEl = document.querySelector("[var-id]");
      if (!varEl) return null;
      var firstvarient = varEl.getAttribute("var-id");
      return parseInt(firstvarient);
    }
  }

  // ----- Get current price -----
  function getCurrentPrice() {
    try {
      const variantId = getVariantFromURL();
      if (!variantId || isNaN(variantId)) return 0;

      const elements = document.querySelectorAll('input[name="id"]');
      elements.forEach((element) => {
        element.value = variantId;
      });

      const priceContainer = document.querySelector(`div[var-id="${variantId}"]`);
      if (!priceContainer) return 0;

      const priceElement = priceContainer.querySelector('span') || priceContainer;
      const priceText = priceElement.innerText.trim();
      const regex = /(\d+(?:[.,]\d+)?)/g;
      const matches = priceText.match(regex);
      let priceString = matches && matches[0] ? matches[0] : "0";
      priceString = priceString.replace(",", ".");

      const price = parseFloat(priceString);
      return isNaN(price) ? 0 : price;
    } catch (error) {
      console.error("Error in getCurrentPrice:", error);
      return 0;
    }
  }

  // ----- Populate size and quantity options -----
  function populateOptions() {
    const sizeOptions = document.getElementById("size-options");
    const quantityOptions = document.getElementById("quantity-options");

    if (sizeOptions && quantityOptions && typeof data !== 'undefined') {
      if (data.sizes) {
        data.sizes.forEach((size) => {
          const label = document.createElement("label");
          label.classList.add("size_options", "form__label");
          label.innerHTML = `<input type="radio" name="dimensions" value="${size.value}" onchange="toggleCustomSizeInput(this)" data-total="${size.total}" /> ${size.label}`;
          sizeOptions.appendChild(label);
        });
      }

      if (data.quantities) {
        data.quantities.forEach((quantity, index) => {
          var dynamic_save;
          if (quantity.discount != 0) {
            dynamic_save = `-${quantity.discount}%`;
          } else {
            dynamic_save = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
          }

          const pcsText = quantity.value !== "custom" ? " pcs" : "";

          const div = document.createElement("div");
          div.innerHTML = `<label class="quantity-options form__label">
                            <div class="quantity-data">
                                <input class="radio-inp" type="radio" name="quantity" value="${quantity.value}" onchange="toggleCustomQuantityInput(this)" /> &nbsp; ${quantity.label}${pcsText}</div>
                            <div class="dynamic_price" data-quantity="${quantity.value}" data-save="${quantity.discount}"></div>
                            <div class="dynamic_sav dynamic_save_${index}" data-save="${quantity.value}">${dynamic_save}</div>
                        </label>`;
          quantityOptions.appendChild(div);
        });
      }

      const urlVariant = new URLSearchParams(window.location.search).get("variant");
      const selectedSizeValue = getSizeFromURL() || getSizeFromLocalStorage();
      const selectedQuantityValue = getQuantityFromURL() || getQuantityFromLocalStorage();

      let sizeSelected = false;
      if (urlVariant) {
        sizeSelected = selectSizeBasedOnVariant(parseInt(urlVariant));
      }
      if (!sizeSelected && selectedSizeValue) {
        sizeSelected = selectSizeBasedOnValue(selectedSizeValue);
      }
      if (!sizeSelected) {
        const firstSizeRadio = document.querySelector('#size-options input[type="radio"]');
        if (firstSizeRadio) {
          firstSizeRadio.checked = true;
          toggleCustomSizeInput(firstSizeRadio);
          const firstLabel = firstSizeRadio.closest("label");
          const dropdown = document.querySelector(".size-dropdown");
          if (dropdown && firstLabel) dropdown.textContent = firstLabel.textContent.trim();
          sizeSelected = true;
        }
      }

      let qtySelected = false;
      if (selectedQuantityValue) {
        qtySelected = selectQuantityBasedOnValue(selectedQuantityValue);
      }
      if (!qtySelected) {
        const qtyRadios = document.querySelectorAll('#quantity-options input[type="radio"]');
        if (qtyRadios && qtyRadios.length > 0) {
          const defaultRadio = qtyRadios[0];
          defaultRadio.checked = true;
          toggleCustomQuantityInput(defaultRadio);
          const option = defaultRadio.closest(".quantity-options");
          if (option) option.style.background = "#ececec";
          qtySelected = true;
        }
      }
    }
  }

  function getSizeFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const size = urlParams.get("size");
    return size ? size : null;
  }

  function getQuantityFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const quantity = urlParams.get("quantity");
    return quantity ? quantity : null;
  }

  function getSizeFromLocalStorage() { return localStorage.getItem("selectedSize"); }
  function getQuantityFromLocalStorage() { return localStorage.getItem("selectedQuantity"); }
  function saveSizeToLocalStorage(size) { localStorage.setItem("selectedSize", size); }
  function saveQuantityToLocalStorage(quantity) { localStorage.setItem("selectedQuantity", quantity); }

  function selectSizeBasedOnVariant(variantValue) {
    const sizeRadios = document.querySelectorAll('#size-options input[type="radio"]');
    let matched = false;
    sizeRadios.forEach((radio) => {
      if (parseInt(radio.getAttribute("data-total")) === variantValue) {
        radio.checked = true;
        toggleCustomSizeInput(radio);
        const label = radio.closest("label");
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown && label) dropdown.textContent = label.textContent.trim();
        matched = true;
      }
    });
    return matched;
  }

  function selectSizeBasedOnValue(sizeValue) {
    const sizeRadios = document.querySelectorAll('#size-options input[type="radio"]');
    let matched = false;
    sizeRadios.forEach((radio) => {
      if (radio.value === sizeValue || radio.getAttribute("data-total") == sizeValue) {
        radio.checked = true;
        toggleCustomSizeInput(radio);
        const label = radio.closest("label");
        const dropdown = document.querySelector(".size-dropdown");
        if (dropdown && label) dropdown.textContent = label.textContent.trim();
        matched = true;
      }
    });
    return matched;
  }

  function selectQuantityBasedOnValue(quantityValue) {
    const quantityRadios = document.querySelectorAll('#quantity-options input[type="radio"]');
    let matched = false;
    quantityRadios.forEach((radio) => {
      if (radio.value === quantityValue) {
        radio.checked = true;
        toggleCustomQuantityInput(radio);
        const option = radio.closest(".quantity-options");
        if (option) option.style.background = "#ececec";
        matched = true;
      }
    });
    return matched;
  }

  // ----- Lamination checkbox -----
  const checkbox = document.getElementById("enable_lamination");
  function uncheckCheckbox() {
    if (!checkbox) return;
    checkbox.checked = false;
    checkbox.dispatchEvent(new Event("change"));
    checkbox.setAttribute("name", "properties[Pelliculage]");
  }
  if (checkbox) {
    uncheckCheckbox();
    checkbox.addEventListener("change", function () {
      var updatedP = getSizeFromLocalStorage();
      checkbox.setAttribute("name", "properties[Pelliculage]");
      const finalLami = document.querySelector("#final-lami");
      if (this.checked) {
        variantHandler(updatedP);
        if (finalLami) finalLami.innerHTML = "Oui";
        checkbox.value = "Oui";
      } else {
        variantHandler(updatedP);
        if (finalLami) finalLami.innerHTML = "Non";
        checkbox.value = "Non";
      }
    });
  }

  // ----- Update main total price -----
  function updatePrice(selectedQuantity) {
    let price = 0;
    let discount = 0;

    if (!isNaN(selectedQuantity) && typeof data !== 'undefined' && data.quantities) {
      let basePrice = getCurrentPrice();

      const selectedQuantityObj = data.quantities.reduce((prev, curr) => {
        return selectedQuantity >= curr.value ? curr : prev;
      });

      if (selectedQuantityObj) {
        discount = selectedQuantityObj.discount || 0;
      }

      let unitPrice = (basePrice * (100 - discount)) / 100;
      unitPrice = Math.ceil(unitPrice * 100) / 100;
      price = selectedQuantity * unitPrice;

      const totalBig = document.querySelector("#total-big");
      if (totalBig) totalBig.innerHTML = `€${price.toFixed(2)}`;
    } else {
      const totalBig = document.querySelector("#total-big");
      if (totalBig) totalBig.innerHTML = "Invalid quantity";
    }

    const quantityElement = document.querySelector(".quantity__input");
    if (quantityElement) {
      quantityElement.value = selectedQuantity;
      quantityElement.setAttribute("value", selectedQuantity);
    }
    saveQuantityToLocalStorage(selectedQuantity);
  }

  // ----- Main variant handler -----
  function variantHandler(sizeValue) {
    try {
      const lamiCheckbox = document.querySelector("#enable_lamination");
      const isLaminated = !!(lamiCheckbox && lamiCheckbox.checked);

      // Handle separate Pelliculage option fieldset if options are separated
      const fieldsets = document.querySelectorAll(".product-form__input--pill");
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector("legend")?.textContent?.trim()?.toLowerCase() || "";
        if (legend.includes("pelliculage") || legend.includes("lamination") || legend.includes("finition") || legend.includes("finish")) {
          const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          radios.forEach(r => {
            const val = r.value.trim().toLowerCase();
            if (isLaminated) {
              if (val === "oui" || val === "yes" || val.includes("avec") || val === "pelliculage") {
                r.checked = true;
                r.dispatchEvent(new Event("change", { bubbles: true }));
              }
            } else {
              if (val === "non" || val === "no" || val.includes("sans") || val === "standard" || val === "aucun") {
                r.checked = true;
                r.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
          });
        }
      });

      let variantInputs = Array.from(document.querySelectorAll(".product-form__input--pill input"));
      if (!variantInputs || variantInputs.length === 0) return;

      const sizeNum = parseFloat(sizeValue);
      if (isNaN(sizeNum)) return;

      const sizeInputs = variantInputs.filter(input => {
        const fieldset = input.closest("fieldset");
        const legend = fieldset?.querySelector("legend")?.textContent?.trim()?.toLowerCase() || "";
        if (legend.includes("pelliculage") || legend.includes("lamination") || legend.includes("finition") || legend.includes("finish")) {
          return false;
        }
        return true;
      });

      const inputsToUse = sizeInputs.length > 0 ? sizeInputs : variantInputs;

      let filteredInputs = [];
      if (isLaminated) {
        filteredInputs = inputsToUse.filter(input => {
          const val = input.value.toLowerCase();
          return val.includes("pel") || val.includes("lam") || val.includes("avec") || !/^\d+(\s*cm²?)?$/i.test(input.value.trim());
        });
        if (filteredInputs.length === 0) filteredInputs = inputsToUse;
      } else {
        filteredInputs = inputsToUse.filter(input => {
          const val = input.value.toLowerCase();
          return !val.includes("pel") && !val.includes("lam") && !val.includes("avec");
        });
        if (filteredInputs.length === 0) filteredInputs = inputsToUse;
      }

      let closestSize = null;
      filteredInputs.forEach(values => {
        let dataValue = parseInt(values.value, 10);
        if (!isNaN(dataValue)) {
          if (closestSize === null || (dataValue >= sizeNum && (closestSize < sizeNum || dataValue < closestSize))) {
            closestSize = dataValue;
          }
        }
      });

      if (closestSize === null) return;

      const matchedInput = filteredInputs.find(values => parseInt(values.value, 10) === closestSize);
      if (matchedInput) {
        matchedInput.checked = true;
        const radioBtn = document.getElementById(matchedInput.id) || matchedInput;
        if (radioBtn) {
          radioBtn.checked = true;
          const changeEvent = new Event("change", { bubbles: true, cancelable: true });
          radioBtn.dispatchEvent(changeEvent);
          radioBtn.click();

          setTimeout(() => {
            const updated_price = getCurrentPrice();
            if (isNaN(updated_price)) return;
            document.querySelectorAll("#quantity-options .dynamic_price").forEach((d) => {
              var prices;
              const previousSibling = d.previousElementSibling;

              if (d.getAttribute("data-save") != 0) {
                var data_save = 100 - d.getAttribute("data-save");
                var discounted_variant_price = (updated_price / 100) * data_save;
                var round_price = Math.ceil(discounted_variant_price * 100) / 100;
                var total_price = (d.getAttribute("data-quantity") * round_price).toFixed(2);

                if (previousSibling && previousSibling.classList.contains("quantity-data")) {
                  const radioButton = previousSibling.querySelector('input[type="radio"]:checked');
                  if (radioButton) {
                    const totalBig = document.querySelector("#total-big");
                    if (totalBig) totalBig.innerHTML = `€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}`;
                  }
                  const prevRadio = previousSibling.querySelector('input[type="radio"]');
                  if (prevRadio) {
                    prevRadio.setAttribute("data-final-price", `€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}`);
                  }
                }

                prices = `<span class="discounted_price">€${total_price}</span>`;
              } else {
                if (previousSibling && previousSibling.classList.contains("quantity-data")) {
                  const radioButton = previousSibling.querySelector('input[type="radio"]:checked');
                  if (radioButton) {
                    const totalBig = document.querySelector("#total-big");
                    if (totalBig) totalBig.innerHTML = `€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}`;
                  }
                  const prevRadio = previousSibling.querySelector('input[type="radio"]');
                  if (prevRadio) {
                    prevRadio.setAttribute("data-final-price", `€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}`);
                  }
                }

                prices = `
                   <span class="">€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}</span>
                   <span class="discounted_price">&nbsp;</span>  
                 `;
              }
              d.innerHTML = `<div class="prices">${prices}</div>`;
            });
            enableSubmitButton();
          }, 100);
        }
      }
      enableSubmitButton();
    } catch (error) {
      console.error("Error in variantHandler:", error);
    }
  }

  // ----- Custom size input handling -----
  function toggleCustomSizeInput(radio) {
    const customSizeInput = document.getElementById("custom-price-input");
    if (customSizeInput) {
      if (radio.value === "custom") {
        customSizeInput.style.display = "flex";
        var val1 = document.querySelector("#Custom_size1")?.value || "10";
        var val2 = document.querySelector("#Custom_size2")?.value || "10";
        radio.setAttribute("data-total", val1 * val2);
      } else {
        customSizeInput.style.display = "none";
      }
    }

    const sizeValue = radio.getAttribute("data-total");
    variantHandler(sizeValue);
    enableSubmitButton();
    saveSizeToLocalStorage(sizeValue);

    const finalSize = document.querySelector("#final-size");
    if (finalSize) finalSize.innerHTML = `${radio.value} cm`;
    const finalSizeInput = document.querySelector("#final-size-input");
    if (finalSizeInput) finalSizeInput.value = `${radio.value} cm`;
  }

  // ----- Custom size validation & price update -----
  function validateAndMultiply() {
    const input1 = document.getElementById("Custom_size1");
    const input2 = document.getElementById("Custom_size2");
    if (!input1 || !input2) {
      return;
    }

    let value1 = parseFloat(input1.value);
    let value2 = parseFloat(input2.value);
    let err_size = document.getElementById("err_size");
    if (isNaN(value1) || isNaN(value2)) {
      if (err_size) err_size.innerHTML = "Enter height & width";
      return;
    } else {
      if (err_size) err_size.innerHTML = "";
    }
    if (value1 < 2 || value1 > 60 || value2 < 2 || value2 > 60) {
      if (err_size) err_size.innerHTML = "La taille doit être comprise entre 2 et 60";
      return;
    } else {
      if (err_size) err_size.innerHTML = "";
    }
    let result = value1 * value2;
    const finalSize = document.querySelector("#final-size");
    if (finalSize) finalSize.innerHTML = `${value1}x${value2} cm`;
    const finalSizeInput = document.querySelector("#final-size-input");
    if (finalSizeInput) finalSizeInput.value = `${value1}x${value2} cm`;
    variantHandler(result);
    enableSubmitButton();
    saveSizeToLocalStorage(result);

    setTimeout(() => {
      const updated_price = getCurrentPrice();
      document.querySelectorAll("#quantity-options .dynamic_price").forEach((d) => {
        var prices;
        const previousSibling = d.previousElementSibling;

        if (d.getAttribute("data-save") != 0) {
          var data_save = 100 - d.getAttribute("data-save");
          var discounted_variant_price = (updated_price / 100) * data_save;
          var round_price = Math.ceil(discounted_variant_price * 100) / 100;
          if (previousSibling && previousSibling.classList.contains("quantity-data")) {
            const radioButton = previousSibling.querySelector('input[type="radio"]:checked');
            if (radioButton) {
              const totalBig = document.querySelector("#total-big");
              if (totalBig) totalBig.innerHTML = `€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}`;
            }
            const prevRadio = previousSibling.querySelector('input[type="radio"]');
            if (prevRadio) {
              prevRadio.setAttribute("data-final-price", `€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}`);
            }
          }

          prices = `<span class="discounted_price">€${(d.getAttribute("data-quantity") * round_price).toFixed(2)}</span>`;
        } else {
          if (previousSibling && previousSibling.classList.contains("quantity-data")) {
            const radioButton = previousSibling.querySelector('input[type="radio"]:checked');
            if (radioButton) {
              const totalBig = document.querySelector("#total-big");
              if (totalBig) totalBig.innerHTML = `€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}`;
            }
            const prevRadio = previousSibling.querySelector('input[type="radio"]');
            if (prevRadio) {
              prevRadio.setAttribute("data-final-price", `€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}`);
            }
          }

          prices = `
             <span class="">€${(d.getAttribute("data-quantity") * updated_price).toFixed(2)}</span>
             <span class="discounted_price">&nbsp;</span>  
           `;
        }
        d.innerHTML = `<div class="prices">${prices}</div>`;
      });
    }, 100);
  }

  // ----- Custom quantity input handling -----
  function toggleCustomQuantityInput(radio) {
    let customQuantityInput = document.getElementById("custom-quantity-input");
    let customQuantityText = document.getElementById("custom-quantity-text");
    let quantityInput = document.querySelector(".quantity__input");
    let finalDays = document.getElementById("final-days");

    if (customQuantityInput && quantityInput && finalDays) {
      if (radio.value === "custom") {
        customQuantityInput.style.display = "block";
        customQuantityText.style.display = "block";

        updatePrice(100);
        saveQuantityToLocalStorage(100);
        const finalQty = document.querySelector("#final-qty");
        if (finalQty) finalQty.innerHTML = 100;
        updateDays(100);
        customQuantityInput.value = 100;
        radio.value = 100;
        const submitButton = document.querySelector(".product-form__submit");

        customQuantityInput.addEventListener("input", function () {
          let quantity = parseInt(customQuantityInput.value);
          radio.value = quantity;
          let errorMessage = document.querySelector(".custom-error-msg");

          if (!errorMessage) {
            errorMessage = document.createElement("div");
            errorMessage.classList.add("custom-error-msg");
            errorMessage.style.color = "red";
            const targetText = document.querySelector("#custom-quantity-text");
            if (targetText) targetText.before(errorMessage);
          }

          if (quantity < 1 || isNaN(quantity)) {
            errorMessage.style.display = "block";
            errorMessage.innerHTML = "la quantité ne peut pas être négative";
            if (submitButton) submitButton.disabled = true;
          } else {
            errorMessage.innerHTML = "";
            errorMessage.style.display = "none";
            saveQuantityToLocalStorage(100);
            const finalQty = document.querySelector("#final-qty");
            if (finalQty) finalQty.innerHTML = quantity;
            updatePrice(quantity);
            updateDays(quantity);
            if (submitButton) submitButton.disabled = false;
          }
        });

        updatePrice(100);
      } else {
        const radioInputs = document.querySelectorAll(".radio-inp");
        if (radioInputs && radioInputs.length > 0) {
          const lastRadioInput = radioInputs[radioInputs.length - 1];
          if (lastRadioInput) lastRadioInput.value = "custom";
        }

        customQuantityInput.style.display = "none";
        customQuantityText.style.display = "none";
        updatePrice(radio.value);
        saveQuantityToLocalStorage(radio.value);
        const finalQty = document.querySelector("#final-qty");
        if (finalQty) finalQty.innerHTML = radio.value;
        const totalBig = document.querySelector("#total-big");
        if (totalBig) totalBig.innerHTML = radio.getAttribute("data-final-price");
        updateDays(radio.value);
      }
    }

    function updateDays(quantity) {
      let days;
      if (quantity < 300) {
        days = 4;
      } else if (quantity < 500) {
        days = 4;
      } else if (quantity < 1000) {
        days = 5;
      } else {
        days = 6;
      }
      if (finalDays) finalDays.innerHTML = days + " Jours";
    }
  }

  // Bind to window for inline HTML listeners
  function enableSubmitButton() {
    const buttons = document.querySelectorAll('.product-form__submit, [name="add"], #custom-button');
    buttons.forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
    });
  }
  window.enableSubmitButton = enableSubmitButton;
  window.toggleCustomSizeInput = toggleCustomSizeInput;
  window.toggleCustomQuantityInput = toggleCustomQuantityInput;
  window.validateAndMultiply = validateAndMultiply;
  window.updatePrice = updatePrice;
  window.variantHandler = variantHandler;
  window.populateOptions = populateOptions;

  const hasCalculator = document.getElementById("size-options") || document.getElementById("quantity-options") || document.querySelector(".calc");
  if (hasCalculator) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        populateOptions();
        enableSubmitButton();
        setTimeout(enableSubmitButton, 300);
        setTimeout(enableSubmitButton, 800);
      });
    } else {
      populateOptions();
      enableSubmitButton();
      setTimeout(enableSubmitButton, 300);
      setTimeout(enableSubmitButton, 800);
    }

    document.addEventListener("DOMContentLoaded", function () {
      const input1 = document.getElementById("Custom_size1");
      const input2 = document.getElementById("Custom_size2");
      if (input1) input1.addEventListener("input", validateAndMultiply);
      if (input2) input2.addEventListener("input", validateAndMultiply);

      var previewContainer = document.querySelector(".image-preview-container");
      var previewImage = document.getElementById("image_preview");
      const customPhotoInput = document.getElementById("custom_photo");

      if (customPhotoInput && previewImage) {
        customPhotoInput.addEventListener("change", function (event) {
          const file = event.target.files[0];
          if (file) {
            const fileType = file.type;

            if (fileType.startsWith("image/")) {
              const reader = new FileReader();
              reader.onload = function (e) {
                previewImage.src = e.target.result;
                previewImage.style.display = "block";
              };
              reader.readAsDataURL(file);
            } else if (fileType === "application/pdf") {
              previewImage.src = "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/80942.png?v=1725791225"; // Set PDF icon
              previewImage.style.display = "block";
            } else {
              previewImage.src = "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/page-file-icon.webp?v=1725791274"; // Set default file icon
              previewImage.style.display = "block";
            }
          }
        });
      }

      if (previewContainer && previewImage) {
        previewContainer.addEventListener("mouseenter", function () {
          previewImage.style.transform = "scale(1.05)";
        });

        previewContainer.addEventListener("mouseleave", function () {
          previewImage.style.transform = "scale(1)";
        });
      }
    });
  }
}
